<div class="mb-4" *ngIf="identifier && dataList.length">
  <div class="d-flex align-items-center justify-content-between py-2">
    <h2 class="h5 d-flex align-items-center car-title mb-0">
      <app-svg-icon class="variable-svg-icon me-1" [pathIdentifier]="identifier"></app-svg-icon>
      <a class="h6 fw-bold mb-0 text-decoration-none" [routerLink]="routerLink">{{ title | translate : {param: translateParam} }} </a>
    </h2>

    <div *ngFor="let carousel of carousels" [class]="carousel.displayClass">
      <div *ngIf="carousel.slides && carousel.slides.length > 1" class="d-flex flex-nowrap">
        <button class="btn btn-secondary btn-sm ms-2 py-1 px-3" type="button" (click)="moveSlide('prev', carousel.size, identifier)" [disabled]="!currentSlideIndex">
          <span class="" aria-hidden="true"> < </span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="btn btn-secondary btn-sm ms-2 py-1 px-3" type="button" (click)="moveSlide('next', carousel.size, identifier)"  [disabled]="currentSlideIndex === carousel.slides.length-1">
          <span class="" aria-hidden="true"> > </span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>



  <div *ngFor="let carousel of carousels" [id]="'carousel' + carousel.size + identifier.toUpperCase()" class="carousel slide" [ngClass]="carousel.displayClass" data-bs-interval="1000">
    <div class="carousel-inner">
      <div *ngFor="let slide of carousel.slides; let idx = index" class="carousel-item" [ngClass]="{'active': idx === 0}">
        <div class="car-item-wrapper">
          <div class="{{'car-item-'+carousel.size.toLowerCase()}}"
               *ngFor="let item of slide; let j=index"
               [ngClass]="{'clickable': (carousel.size ==='Sm' || carousel.size === 'Xs') || j < carousel.itemsPerSlide - 1 || (j===carousel.itemsPerSlide-1 && carousel.slides && idx===carousel.slides.length-1), 'half-div': carousel.size !=='Sm' && carousel.size !== 'Xs' && j===carousel.itemsPerSlide-1 && idx!==numOfSlides-1, 'default-cursor': !item.name}">
            <div class="h-100" style="aspect-ratio: 1/1;">
              <div class="shadow" [ngClass]="{'visually-hidden': !item.name}">
<!--              <div class="shadow" [ngClass]="{'visually-hidden': !debugNameAccess(item)}">-->
                <a [routerLink]="(item.launchUrl && item.enabled !== false && item.disabledByPromo !== true ? '/play/' : '/details/') + item.slug" [ngClass]="{'image-with-flag': !(carousel.size !=='Sm' && carousel.size !== 'Xs' && j===carousel.itemsPerSlide-1 && idx!==numOfSlides-1)}">
                  <ng-container *ngIf="isGame(item)">
                    <img [src]="item.getImage('256x256')" [alt]="item.name" class="rounded" [ngClass]="{'disabled-game': item.enabled === false || item.disabledByPromo === true}" style="width: 100%; height: auto; aspect-ratio: 1/1;" loading="lazy" (error)="updateNotFoundImgUrl($event)">
                  </ng-container>
                  <div *ngIf="item.tag && (item.tag.includes('beta') || item.tag.toLowerCase().includes('prelaunch')) && !(carousel.size !=='Sm' && carousel.size !== 'Xs' && j===carousel.itemsPerSlide-1 && idx!==numOfSlides-1)" class="flag d-flex flex-row align-items-center">
                    <img src="assets/icons/beta_sign.svg" alt="beta sign">
                    <small class="ms-1">BETA</small>
                  </div>
                </a>
                <app-like-label *ngIf="carousel.size ==='Sm' || carousel.size === 'Xs' || j!==carousel.itemsPerSlide-1 || idx===numOfSlides-1" [game]="item" [favouriteGameIds]="favouriteIds"></app-like-label>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</div>
